import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css'; // Reuse the same professional CSS

const LoginPage = () => {
	const [loginData, setLoginData] = useState({ email: '', password: '' });
	const [errors, setErrors] = useState({});
	const [isSubmitting, setIsSubmitting] = useState(false);
	const navigate = useNavigate();

	const handleChange = (e) => {
		const { name, value } = e.target;
		setLoginData(prev => ({ ...prev, [name]: value }));
		// Clear error as user types
		if (errors[name]) setErrors(prev => ({ ...prev, [name]: "" }));
	};

	const validate = () => {
		let tempErrors = {};
		if (!/\S+@\S+\.\S+/.test(loginData.email)) tempErrors.email = "Invalid email format.";
		if (!loginData.password) tempErrors.password = "Password is required.";

		setErrors(tempErrors);
		return Object.keys(tempErrors).length === 0;
	};
	
	const getOrGenerateDeviceId = () => {
	    let deviceId = localStorage.getItem('deviceId');
	    if (!deviceId) {
	        // Use crypto.randomUUID() for modern browsers
	        deviceId = window.crypto.randomUUID ? window.crypto.randomUUID() : 'manual-fallback-uuid-' + Date.now();
	        localStorage.setItem('deviceId', deviceId);
	    }
	    return deviceId;
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!validate()) return;

		setIsSubmitting(true);
		try {
			const deviceId = getOrGenerateDeviceId();
			const response = await fetch('/api/v1/auth/login', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'X-Device-Id': deviceId },
				body: JSON.stringify(loginData)
			});

			if (response.ok) {
				// Matches your AuthResponse POJO structure
				const { accessToken, refreshToken, tokenType, expiresIn } = await response.json();

				// 1. Store tokens in localStorage

				localStorage.setItem('accessToken', accessToken);
				localStorage.setItem('refreshToken', refreshToken);
				localStorage.setItem('tokenType', tokenType);

				// 2. Optional: Store expiry time to check before API calls
				const expiryDate = new Date().getTime() + (expiresIn * 1000);
				localStorage.setItem('expiresAt', expiryDate);

				navigate('/dashboard')
			} else if (response.status === 400 || response.status === 401) {
				const errorData = await response.json();
				setErrors({ general: errorData.message });
				setIsSubmitting(false);

			}
		} catch (error) {
			// This catch block is triggering because 'data' is undefined above, 
			// which JS treats as a fatal error during execution.
			console.error("Actual JS Error:", error);
			alert("Network error.");
		} finally {
			setIsSubmitting(false);
		}
	};


	return (
		<div className="registration-container">
			<form className="registration-form" onSubmit={handleSubmit}>
				<button type="button" className="home-btn" onClick={() => navigate('/')}>
					← Home
				</button>
				<h2>Professionals Login</h2>

				<div className="form-group">
					<input
						name="email"
						type="email"
						placeholder="Email Address"
						onChange={handleChange}
						className={errors.email ? 'input-error' : ''}
						required
					/>
					{errors.email && <span className="error-text">{errors.email}</span>}
				</div>

				<div className="form-group">
					<input
						name="password"
						type="password"
						placeholder="Password"
						onChange={handleChange}
						className={errors.password ? 'input-error' : ''}
						required
					/>
					{errors.password && <span className="error-text">{errors.password}</span>}
				</div>

				{errors.general && <div className="error-text" style={{ textAlign: 'center', marginBottom: '10px' }}>{errors.general}</div>}

				<button
					type="submit"
					disabled={isSubmitting}
					className="submit-btn"
				>
					{isSubmitting ? <div className="loader"></div> : "Login"}
				</button>

				<p style={{ textAlign: 'left', marginTop: '15px' }}>
					Don't have an account? <span style={{ color: '#4f46e5', cursor: 'pointer' }} onClick={() => navigate('/register')}>Register here</span>
				</p>
				<p style={{ textAlign: 'right', marginTop: '15px' }}>
					Forgot Password? <span style={{ color: '#4f46e5', cursor: 'pointer' }} onClick={() => navigate('/forgotPassword')}>Click here</span>
				</p>
			</form>
		</div>
	);
};

export default LoginPage;
